<script setup>
import {computed, inject} from 'vue';

const props = defineProps({
  icon: {type: String, required: true},
  filled: {type: Boolean, default: false},
  margin: {type: Boolean, default: true}
})

const composables = inject('composables');
const {getJurisdictionByLocale} = composables.useJurisdictionSwitch();
import {useI18n} from 'vue-i18n';
const {locale} = useI18n({useScope: 'global'});
import {get} from 'lodash';

const classes = computed(() => {
  return [
    `dp-icon__${props.icon}${props.filled ? '--filled' : ''}`,
    {
      'mirror-horizontally': get(getJurisdictionByLocale(locale.value), 'rtl', false),
      'inline-margin': props.margin
    }
  ]
});
</script>
<script>
export default {
  name: "DpIcon"
};
</script>

<template>
  <i :class="classes"/>
</template>
